import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Scrollbars } from 'react-custom-scrollbars';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import EmailIcon from '@material-ui/icons/Email';
import PrintIcon from '@material-ui/icons/Print';
import FilterListIcon from '@material-ui/icons/FilterList';
import ReactToPrint from 'react-to-print';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const rows = [
  { id: 'first_name', numeric: false, disablePadding: false, label: "Vorname" },
  { id: 'last_name', numeric: false, disablePadding: false, label: "Nachname" },
  { id: 'city', numeric: false, disablePadding: false, label: "Ortsteil" },
  { id: 'age', numeric: true, disablePadding: false, label: "Alter" },
  { id: 'tel', numeric: false, disablePadding: false, label: "Telefonnummer" },
  { id: 'note', numeric: false, disablePadding: false, label: "Anmerkung" },
  { id: 'photo_permission', numeric: false, disablePadding: false, label: "Fotoerlaubnis" },
];

class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox indeterminate={numSelected > 0 && numSelected < rowCount} checked={numSelected === rowCount} onChange={onSelectAllClick} />
          </TableCell>
          {rows.map(row => {
            return (
              <TableCell key={row.id} align={row.numeric ? 'right' : 'left'} padding={row.disablePadding ? 'none' : 'default'} sortDirection={orderBy === row.id ? order : false} >
                <Tooltip title="Sortieren" placement={row.numeric ? 'bottom-end' : 'bottom-start'} enterDelay={300} >
                  <TableSortLabel active={orderBy === row.id} direction={order} onClick={this.createSortHandler(row.id)}>{row.label}</TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing(1),
    height: 60
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});

let EnhancedTableToolbar = props => {
  const { numSelected, classes } = props;

  return (
    <Toolbar className={clsx(classes.root, { [classes.highlight]: numSelected > 0 })} >
      <div className={classes.title}>
        {numSelected > 0 ? (<Typography color="inherit" variant="subtitle1">{numSelected} Teilnehmer ausgewählt</Typography>) : (<Typography variant="h6" id="tableTitle">{"Teilnehmerliste für \"" + props.name + "\""}</Typography>)}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <div style={{ width: 96 }}>
            <Tooltip title={"Email an alle ausgewählten Teilnehmer"}>
              <IconButton onClick={props.onEmail}>
                <EmailIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Löschen"}>
              <IconButton disabled>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          <div style={{ width: 96 }}>
            <Tooltip title={"Teilnehmerliste ausdrucken"}>
              <IconButton onClick={props.onClick}>
                <PrintIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Bald verfügbar"}>
              <IconButton>
                <FilterListIcon />
              </IconButton>
            </Tooltip>
          </div>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  onEmail: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({

});

class EnhancedTable extends React.Component {
  state = {
    order: 'asc',
    orderBy: 'last_name',
    selected: [],
    page: 0,
    rowsPerPage: 25,
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') order = 'asc';

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = event => {
    if (event.target.checked) {
      this.setState(state => ({ selected: this.props.data.map(n => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  writeEmailToSelected = () => {
    var emails = "";
    this.state.selected.map((item, key) => {
      return emails = emails + "," + this.props.data[item].email;
    });
    window.location.href = 'mailto:' + this.props.leaderEmail + '?subject=' + this.props.name + '&body=Sehr geehrte Damen und Herren,&bcc=noreply@fepro.formulare-schemmerhofen.de,' + emails.slice(1);
  }

  getColorForAccepted = accepted => {
    if (parseInt(this.props.server_settings.state) < 4) return "black";
    if (accepted === "J" || accepted === "C") return green[600];
    if (accepted === "L" || accepted === "D") return red[600];
  }

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const { data } = this.props;
    const { order, orderBy, selected } = this.state;

    return (
      <Fragment>
        <Paper style={{ height: "100%" }}>
          <ReactToPrint trigger={() => <EnhancedTableToolbar numSelected={selected.length} name={this.props.name} onEmail={this.writeEmailToSelected} />} content={() => this.componentRef} />
          <div style={{ height: 'calc(100% - 65px)', overflowX: 'auto' }}>
            <Scrollbars>
              <Table ref={el => (this.componentRef = el)}>
                <EnhancedTableHead numSelected={selected.length} order={order} orderBy={orderBy} onSelectAllClick={this.handleSelectAllClick} onRequestSort={this.handleRequestSort} rowCount={data.length} />
                <TableBody>
                  {stableSort(data, getSorting(order, orderBy))
                    .map(n => {
                      const isSelected = this.isSelected(n.id);
                      return (
                        <TableRow hover onClick={event => this.handleClick(event, n.id)} role="checkbox" aria-checked={isSelected} tabIndex={-1} key={n.id} selected={isSelected}>
                          <TableCell padding="checkbox">
                            <Checkbox checked={isSelected} />
                          </TableCell>
                          <TableCell component="th" scope="row" padding="none" style={{ color: this.getColorForAccepted(n.accepted) }}><b>{n.first_name}</b></TableCell>
                          <TableCell align="left" style={{ color: this.getColorForAccepted(n.accepted) }}><b>{n.last_name}</b></TableCell>
                          <TableCell align="left" style={{ color: this.getColorForAccepted(n.accepted) }}>{n.city}</TableCell>
                          <TableCell align="right" style={{ color: this.getColorForAccepted(n.accepted) }}>{n.age}</TableCell>
                          <TableCell align="left" style={{ color: this.getColorForAccepted(n.accepted) }}>{n.tel}</TableCell>
                          <TableCell align="left" style={{ color: this.getColorForAccepted(n.accepted) }}>{n.note}</TableCell>
                          <TableCell align="left" style={{ color: this.getColorForAccepted(n.accepted) }}>{n.photo_permission}</TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </Scrollbars>
          </div>
        </Paper>
      </Fragment>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  leaderEmail: PropTypes.string.isRequired,
  server_settings: PropTypes.object.isRequired,
};

export default withStyles(styles)(EnhancedTable);
